<template>
  <div>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="update">
        <validation-provider
          v-slot="{ errors }"
          rules="required|numeric"
          name="phoneNumber"
        >
          <div class="form-group">
            <input
              v-model="customer.phone"
              type="text"
              class="form-control form-control-solid"
              :placeholder="$t('Enter phone number')"
            />
            <span class="error">{{ errors[0] }}</span>
          </div>
        </validation-provider>
      </form>

      <button
        type="button"
        class="btn btn-primary btn-lg"
        :disabled="invalid || loading"
        @click="update()"
      >
        <span v-if="!loading">
          {{ $t("Save") }}
        </span>
        <span v-else>
          {{ $t("please wait...") }}
        </span>
      </button>
    </ValidationObserver>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "BaseUpdatePhone",

  data: () => ({
    customer: {
      customer_id: 0,
      phone: null,
    },
  }),
  computed: {
    user() {
      return store.getters["auth/user"];
    },
    loading() {
      return store.getters["auth/loadingUpdateUser"];
    },
  },
  methods: {
    async update() {
      this.customer.customer_id = this.user.id;
      await store.dispatch("auth/updatePhoneNumber", this.customer);
      this.close();
    },
    close() {
      return this.$emit("input", false);
    },
  },
};
</script>